import { render } from "./StrapHome.vue?vue&type=template&id=f116b2d2&scoped=true"
import script from "./StrapHome.vue?vue&type=script&lang=js"
export * from "./StrapHome.vue?vue&type=script&lang=js"

import "./StrapHome.vue?vue&type=style&index=0&id=f116b2d2&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f116b2d2"]])

export default __exports__